import {Flows, ScreenName} from 'navigations/Screens';
import React from 'react';

export interface TabbarComponentProps {
  activeName: Flows | ScreenName;
}

const TabbarComponent = (props: TabbarComponentProps) => {
  return <></>;
};

export default TabbarComponent;
